/* eslint-disable */
// DO NOT TOUCH THESE NUMBERS UNLESS YOU KNOW WHAT YOU ARE DOING

export const ECG_MARGIN = 40;
export const TOOLBAR_HEIGHT = 40;

// these are needed for rendering on headless webkit
const QT_WEBKIT_SCREEN_WIDTH = 800;
const QT_WEBKIT_PX_PER_MM = 0.00463177397;

// MV - milli-Volt -  mostly used for y-axis plot / measurement
// MM - millimeter - mostly in x-axis, convert into time (sec)

export const PX_PER_MM =
  window.innerWidth > 0 ? 4 : QT_WEBKIT_SCREEN_WIDTH * QT_WEBKIT_PX_PER_MM;

export const GAIN_MM_PER_MV = 10;
// +-3 mV for a total 6mV swing
export const MV_BANDWIDTH = 2.5;
// mm/sec
export const PAPER_SPEED = 25;
export const MEDIAN_BEAT_ZOOM = 2;

export const PX_PER_MV = GAIN_MM_PER_MV * PX_PER_MM;
export const PX_PER_SECOND = PAPER_SPEED * PX_PER_MM;

export const SVG_OFFSET = 0.5;

export const SAMPLE_UNITS_PER_MV = 2000;

export const WAVEFORM_BLACK = '#bb2739';
export const LIGHT_RED = '#69696933';
export const DARK_RED = '#69696966';

export const leadTextMap = {
  leadI: 'Lead I',
  leadII: 'Lead II',
  leadIII: 'Lead III',
  aVR: 'aVR',
  aVL: 'aVL',
  aVF: 'aVF',
};

export const leadColorMap = {
  leadI: '#888888',
  leadII: '#11202c',
  leadIII: '#422b47',
  aVR: '#1cacb2',
  aVL: '#1eb21c',
  aVF: '#7d7f0c',
};

export const BEAT_TYPES = {
  GHOST: {
    label: 'ghost',
    key: 'g',
    fill: '#747474ad',
    stroke: '#7d7c7c36',
  },
  PURPLE: {
    label: 'Purple',
    key: 'p',
    fill: '#673ab7',
    stroke: '#8561c5',
  },
  BLUE: {
    label: 'Blue',
    key: 'b',
    fill: '#03a9f4',
    stroke: '#35baf6',
  },
  GREEN: {
    label: 'Green',
    key: 'g',
    fill: '#4caf50',
    stroke: '#6fbf73',
  },
  YELLOW: {
    label: 'Yellow',
    key: 'y',
    fill: '#ffc107',
    stroke: '#ffcd38',
  },
};

export const FIDUCIAL_POINT_TYPES = [
  { name: "P Onset", slug: "p_onset", color: "#CC99FF" },
  { name: "P Offset", slug: "p_offset", color: "#FF6961" },
  { name: "QRS Onset", slug: "qrs_onset", color: "#436B95" },
  { name: "QRS Offset", slug: "qrs_offset", color: "#507D2A" },
  { name: "T Offset", slug: "t_offset", color: "#F28500" },
];

// Annotations that mark a waveform position but are not beat classifications:
// they never contribute to median-beat computation. `field` is the key under
// `annotations` both in Redux and on disk. `peakSearchHalfWindowSec` narrows
// the click-to-peak snap radius: the default R-peak window (133 ms) is wider
// than a QRS complex, so a tall neighbour would otherwise steal the snap from
// these low-amplitude or very thin features.
export const ADDITIONAL_LABEL_TYPES = [
  {
    name: "P-Wave Peak",
    slug: "q",
    color: "#FF80C0",
    field: "pWaves",
    // ~24 ms: enough to correct a slightly-off click within the P wave
    // (80-100 ms wide) without reaching the QRS.
    peakSearchHalfWindowSec: 0.024,
  },
  {
    name: "Atrial Pace Spike",
    slug: "r",
    color: "#87FF2A",
    field: "atrialPaceSpikes",
    // Pace spikes are only a few ms wide. Snap essentially where clicked,
    // allowing a 1-2 sample correction onto the spike's apex.
    peakSearchHalfWindowSec: 0.008,
  },
  {
    name: "Ventricular Pace Spike",
    slug: "g",
    color: "#00B3FF",
    field: "ventricularPaceSpikes",
    peakSearchHalfWindowSec: 0.008,
  },
];

// Arrow glyph for the markers above, drawn with its tip at the origin and the
// shaft rising upward, so translating to the annotated sample puts the tip on
// the trace and leaves the waveform itself unobscured.
export const ADDITIONAL_LABEL_ARROW_HEIGHT = 22;
export const ADDITIONAL_LABEL_ARROW_PATH =
  "M 0 0 L -5 -9 L -1.25 -9 L -1.25 -22 L 1.25 -22 L 1.25 -9 L 5 -9 Z";

// Convert the Redux `{i}` markers into the on-disk
// `{label, sample, duration}` entries, keyed by annotations field.
export const serializeAdditionalLabels = (annotations) => {
  const out = {};
  for (const type of ADDITIONAL_LABEL_TYPES) {
    out[type.field] = (annotations?.[type.field] || []).map((marker) => ({
      label: type.slug,
      sample: marker.i,
      duration: 1,
    }));
  }
  return out;
};

export const MEDIAN_BEAT_FREQUENCY_12_LEAD = 150;

// Median beats from all lead configurations are resampled to this rate for
// display and fiducial-point interaction. Higher than any native rate so
// pixel↔sample↔ms conversions have sub-2ms precision.
export const MEDIAN_BEAT_TARGET_HZ = 600;

// Default half-width (in ms) of the window used to compute a median beat,
// on either side of the R-peak. Non-12-lead recordings default both left and
// right to this until the user adjusts the sliders.
export const DEFAULT_MEDIAN_BEAT_WINDOW_MS = 600;
export const DEFAULT_MEDIAN_BEAT_WINDOW = {
    leftMs: DEFAULT_MEDIAN_BEAT_WINDOW_MS,
    rightMs: DEFAULT_MEDIAN_BEAT_WINDOW_MS,
};
